var map = {
	"./basketball-active.webp": 1474,
	"./basketball.webp": 1475,
	"./bg.webp": 1476,
	"./football-active.webp": 1477,
	"./football.webp": 1478,
	"./games-active.webp": 1479,
	"./games.webp": 1480,
	"./information.webp": 1481,
	"./live-streaming-cover.webp": 1482,
	"./lv-active-bg.webp": 1483,
	"./video-bg.webp": 1484,
	"./video-icon.webp": 1485,
	"./vs.webp": 1486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 466;